// extracted by mini-css-extract-plugin
export default {"header":"mnJZUkvA8bMtSD9OhSkA"};